export const TENANCY_CUSTOMIZED = 'customized';
